<div class="patient-invite-card">
    <nb-card>
      <nb-card-body>
        
        <!-- Disabled state for assistants without employers -->
        <div *ngIf="isAssistantWithNoEmployers" class="disabled-state">
          <nb-icon icon="alert-circle-outline" status="warning"></nb-icon>
          <p>{{'patientInvite.noEmployerWarning' | translate}}</p>
        </div>
        <!-- Form - Single Line Layout -->
        <div *ngIf="canInvite && !inviteSuccess" class="form-container">
          <!-- Left: Icon with large plus -->
          <div class="icon-container">
            <nb-icon icon="person-add-outline" [options]="{ animation: { type: 'pulse' } }" status="primary" style="width: 1.5em;"></nb-icon>
          </div>
          <!-- Middle: Input fields -->
          <div class="inputs-row">
            <input
              nbInput
              type="email"
              [showStatusIconOn]="{ showOnControlStatus: ['valid','invalid'] }"
              [placeholder]="'patientInvite.emailPlaceholder' | translate"
              fieldSize="medium"
              [status]="inviteForm.get('email').valid ? 'success' : inviteForm.get('email').touched && inviteForm.get('email').invalid ? 'danger' : 'basic'"
              [formControl]="inviteForm.get('email')">
            <input
              nbInput
              type="text"
              [showStatusIconOn]="{ showOnControlStatus: ['valid','invalid'] }"
              [placeholder]="'patientInvite.firstNamePlaceholder' | translate"
              fieldSize="medium"
              [status]="inviteForm.get('firstName').valid ? 'success' : inviteForm.get('firstName').touched && inviteForm.get('firstName').invalid ? 'danger' : 'basic'"
              [formControl]="inviteForm.get('firstName')">
            <input
              nbInput
              type="text"
              [showStatusIconOn]="{ showOnControlStatus: ['valid','invalid'] }"
              [placeholder]="'patientInvite.lastNamePlaceholder' | translate"
              fieldSize="medium"
              [status]="inviteForm.get('lastName').valid ? 'success' : inviteForm.get('lastName').touched && inviteForm.get('lastName').invalid ? 'danger' : 'basic'"
              [formControl]="inviteForm.get('lastName')">

            <input
              nbInput
              placeholder="Date of birth"
              fieldSize="medium"
              [nbDatepicker]="birthDatePicker"
              [status]="inviteForm.get('birthDate').valid ? 'success' : inviteForm.get('birthDate').touched && inviteForm.get('birthDate').invalid ? 'danger' : 'basic'"
              [formControl]="inviteForm.get('birthDate')">
            <nb-datepicker #birthDatePicker format="dd.MM.yyyy" [max]="today"></nb-datepicker>

            <!-- Doctor selection for assistants with multiple employers -->
            <nb-select
              *ngIf="isAssistant && allowedPrincipals.length > 1"
              [(ngModel)]="selectedPrincipalId"
              required
              [showStatusIconOn]="{ showOnControlStatus: ['valid','invalid'] }"
              [placeholder]="'patientInvite.selectDoctor' | translate"
              [status]="selectedPrincipalId ? 'success' : 'danger'">
              <nb-option *ngFor="let principal of allowedPrincipals" [value]="principal.documentId">
                Dr. {{ principal.firstName }} {{ principal.lastName }}
              </nb-option>
            </nb-select>
          </div>
          <!-- Right: Invite Button -->
          <button nbButton status="primary" 
                  [disabled]="inviteForm.invalid || (isAssistant && allowedPrincipals.length > 1 && !selectedPrincipalId) || isLoading"
                  (click)="sendInvite()"
                  class="invite-button">
            <nb-icon *ngIf="isLoading" icon="loader-outline" class="spin"></nb-icon>
            <span *ngIf="!isLoading">{{'patientInvite.button' | translate}}</span>
          </button>
        </div>
        <!-- Single employer info (shown below the form row) -->
        <span *ngIf="canInvite && !inviteSuccess && isAssistant && allowedPrincipals.length === 1" class="info-text">
          {{'patientInvite.assignedTo' | translate}} {{ allowedPrincipals[0]?.firstName }} {{ allowedPrincipals[0]?.lastName }}
        </span>
        <!-- Error message -->
        <span *ngIf="inviteError" class="error-text">{{ inviteError }}</span>
        <!-- Success state -->
        <div *ngIf="inviteSuccess" class="success-state">
          <nb-icon icon="checkmark-circle-outline" status="success"></nb-icon>
          <span class="success-text">{{ successMessage }}</span>
          <button nbButton status="primary" (click)="resetForm()">OK</button>
        </div>
      </nb-card-body>
    </nb-card>
  </div>